import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;

const SECTION_W = 2 * IN;
const SECTION_GAP = 0.3 * IN;
const CAP_H = 0.5 * IN;
const FOOT_H = 1.25 * IN;
const FOOT_W = 1.5 * IN;

export function RadiatorSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <RadiatorSide
          depth={depth}
          height={height}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      </SchematicShell>
    );
  }

  // FRONT
  const capTopY = CAP_H;
  const bodyBottom = height - FOOT_H;
  const capBottomY = bodyBottom - CAP_H;

  const step = SECTION_W + SECTION_GAP;
  const numSections = Math.max(2, Math.round((width - SECTION_GAP) / step));
  const totalW = numSections * SECTION_W + (numSections - 1) * SECTION_GAP;
  const startX = (width - totalW) / 2;

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Top cap */}
      <Line
        x1={0}
        y1={capTopY}
        x2={width}
        y2={capTopY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Bottom cap */}
      <Line
        x1={0}
        y1={capBottomY}
        x2={width}
        y2={capBottomY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Foot line */}
      <Line
        x1={0}
        y1={bodyBottom}
        x2={width}
        y2={bodyBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Section gap lines */}
      {Array.from({ length: numSections - 1 }, (_, i) => {
        const x = startX + SECTION_W + i * step + SECTION_GAP / 2;
        return (
          <Line
            key={`gap-${i}`}
            x1={x}
            y1={capTopY}
            x2={x}
            y2={capBottomY}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        );
      })}
      {/* Foot inner edges */}
      <Line
        x1={FOOT_W}
        y1={bodyBottom}
        x2={FOOT_W}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={width - FOOT_W}
        y1={bodyBottom}
        x2={width - FOOT_W}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}

function RadiatorSide({ depth, height, strokeColor, strokeWidth }) {
  const capTopY = CAP_H;
  const bodyBottom = height - FOOT_H;
  const capBottomY = bodyBottom - CAP_H;

  return (
    <g>
      <Line
        x1={0}
        y1={capTopY}
        x2={depth}
        y2={capTopY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={0}
        y1={capBottomY}
        x2={depth}
        y2={capBottomY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={0}
        y1={bodyBottom}
        x2={depth}
        y2={bodyBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}

RadiatorSchematic.supportsSideViews = true;
